import {FaFacebookF, FaInstagram, FaLinkedinIn, FaTiktok, FaYoutube} from "react-icons/fa";
import {LuHeartHandshake} from "react-icons/lu";
import {FaXTwitter} from "react-icons/fa6";

import LoveIcon from "@mui/icons-material/Favorite"
import Link from "next/link"
import protocolLabs from "assets/img/icons/protocol_labs.svg"
import denverIcon from "assets/img/denver-logo.svg"
import sapling from "assets/img/sapling.png"


function ProtocolPartnership() {
    return (<a className="d-flex flex-column justify-content-start align-items-start pt-20"
               href="https://protocol.ai/" target="_blank">
        <div className="d-flex flex-row pb-2">
            <img src={sapling.src} style={{height: 30}} className="mr-2" alt={"Sapling Image"}/>
            <p className="text-body-emphasis">in</p>
            <LuHeartHandshake className="mr-4 white" size={30}/>
            <p>with</p>
            <img style={{height: 30, paddingLeft: 8}} src={protocolLabs.src}/>
            <p style={{fontFamily: 'aileron, sans-serif', paddingLeft: 4}}>Protocol
                Labs</p>
        </div>
    </a>);
}

export default function Footer({siteConfig, name}) {
    const footerConfig = siteConfig?.footerConfig
    if (!footerConfig) {
        return null
    }

    const {altLogo, logo} = siteConfig
    const {twitterLink, linkedInLink, instagramLink, youtubeLink, tikTokLink} = footerConfig


    return (
      <footer className="footer-wrapper">
        <div className="footer-widgets-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-3 col-md-12 col-12">
                <div className="single-footer-widget wow fadeInLeft">
                  <div className="about-us-widget">
                    <div className="footer-logo d-block">
                      <Link href="#">
                        <img
                          src={altLogo?.url || logo?.url}
                          style={{ width: 150 }}
                          alt={altLogo?.alt || logo?.alt}
                        />
                      </Link>
                    </div>
                    {footerConfig.logoMessage && (
                      <p>{footerConfig.logoMessage}</p>
                    )}
                    <ProtocolPartnership />
                  </div>
                </div>
              </div>
              {footerConfig.menu &&
                footerConfig.menu.map((menu, idx) => (
                  <div
                    key={`${idx}-menu`}
                    className="col-xl-2 col-lg-2 col-md-6 col-12"
                  >
                    <div
                      className="single-footer-widget wow fadeInLeft"
                      data-wow-delay=".2s"
                    >
                      <div className="widget-title">
                        <h5>{menu.title}</h5>
                      </div>
                      <ul>
                        {menu.items &&
                          menu.items.map((item, index) => (
                            <li key={`${index}-item`}>
                              <Link href={item.href}>{item.title}</Link>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                ))}
            </div>
          </div>
          
          <div className="footer-bottom-wrapper">
            <div className="container">
              <div className="footer-bottom-content d-md-flex justify-content-between">
                <div
                  className="site-copyright wow fadeInUp"
                  data-wow-delay=".2"
                  data-wow-duration="1s"
                >
                  <p>
                    &copy; 2024
                    <Link href="/">&nbsp;Perpetual Press</Link>
                  </p>
                  <div className={"footer-grown-with-wrapper"}>
                    <div className="footer-grown-with-wrapper-text d-flex">
                      <p>Grown with</p>
                      <LoveIcon
                        fontSize="medium"
                        style={{ marginLeft: 4, color: "red" }}
                      />
                    </div>
                    <img src={denverIcon.src} style={{ height: 40 }} />
                  </div>
                </div>
                <div
                  className="social-links mt-4 mt-md-0 wow fadeInUp"
                  data-wow-delay=".3"
                  data-wow-duration="1s"
                >
                  {twitterLink && (
                    <a target="_blank" href={twitterLink} rel="noreferrer">
                      <FaXTwitter />
                    </a>
                  )}
                  {instagramLink && (
                    <a target="_blank" href={instagramLink} rel="noreferrer">
                      <FaInstagram />
                    </a>
                  )}
                  {tikTokLink && (
                    <a target="_blank" href={tikTokLink} rel="noreferrer">
                      <FaTiktok />
                    </a>
                  )}
                  {youtubeLink && (
                    <a target="_blank" href={youtubeLink} rel="noreferrer">
                      <FaYoutube />
                    </a>
                  )}
                  {linkedInLink && (
                    <a target="_blank" href={linkedInLink}>
                      <FaLinkedinIn />
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {name && name == "deals" && (
            <div className="footer-amazon-disclaimer">
              <div className="container">
                <p>DataDyno is powered by - YOU - our community</p>
                <p>
                  We may earn a small commission when you buy through our links
                  — at no extra cost to you
                </p>
              </div>
            </div>
          )}
      </footer>
    );
}
